import { injectable, inject } from 'inversify';
import { ActionResult, ErrorTypes } from './../Common';
import { TelegramSymbols } from './symbols';

import ITelegramService from './i-telegram-service';
import ITelegramProvider from './i-telegram-provider';


@injectable()
export default class DefaultTelegramService implements ITelegramService {
    private _telegramProvider: ITelegramProvider;

    constructor(@inject(TelegramSymbols.TelegramProvider) telegramProvider: ITelegramProvider) {
        this._telegramProvider = telegramProvider;
    }

    Success(url: string): string {
        return url;
    }
    Error(title: string, message: string): void {
        // ����� �������� ������� ��� ������
        console.log(title, message);
        throw new Error("Method not implemented.");
    }
    async ProcessNumber(phone: string, message: string): Promise<ActionResult<String>> {
        return await this._telegramProvider.ProcessNumber(phone, message);
    };
    
}